import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { TreeList, Selection, Column, Lookup, Editing } from 'devextreme-react/tree-list';
import { SelectBox } from 'devextreme-react';
import CachedIcon from "@material-ui/icons/Cached";
import AddButton from "../../../../../../../ui/AddButton";
import SquareButton from "../../../../../../../ui/SquareButton";
import Box from "../../../../../../../ui/Box";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #treeContainer": {
      height: "300px"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class DepartmentsEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      depList: this.props.departmentsList,
      //selectedRoles: [],
      //focusedRole: -1,
      //focusedRowIndex: -1
    };
/*
    this.selectRoles = this.selectRoles.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
    this.onFormChange = this.props.onFormChange.bind(this);*/

    this.onFormChange = this.props.onFormChange.bind(this);
    this.DataSourceChange = this.DataSourceChange.bind(this);
  }

  onAddClick() {
    console.log('add department');
  }

  /*selectRoles({ selectedRowsData }) {
    this.setState({ selectedRoles: selectedRowsData });
    this.onFormChange(this.state.selectedRoles);
  }

  onRowClick(e) {
    const focusedRole = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedRole, focusedRowIndex });
  }*/

  onCellPrepared(e) {
    if(e.column.command === 'edit') {
      let addLink = e.cellElement.querySelector('.dx-link-add');

      if(addLink) {
        addLink.remove();
      }
    }
  }
  onEditorPreparing(e) {
    if(e.dataField === 'parentId' && e.row.data.id && e.row.data.id > -1) {
      e.cancel = true;
    }
  }
  onInitNewRow(e) {
    e.data.parentId = null;
  }

  DataSourceChange(e) {
    this.onFormChange(this.state.depList);
  }

  render() {
    const {
      //departmentsList,
      getDepartmets,
      classes,
    } = this.props;
    const { root  } = classes;

    //console.log(this.state.depList);

    return (
      <div className={classes.root}>
{/*        <div className={classes.controls}>
          <div>
            <SquareButton>
              <CachedIcon fontSize="small" onClick={getDepartmets} />
            </SquareButton>
          </div>
          <div>
            <AddButton onClick={this.onAddClick} />
          </div>
        </div>*/}
        <div>
          <TreeList
            elementAttr={{
              id: "treeContainer"
            }}
            dataSource={this.state.depList}
            //showColumnHeaders={false}
            showRowLines={true}
            showBorders={true}
            columnAutoWidth={true}
            wordWrapEnabled={true}
            keyExpr="id"
            parentIdExpr="parentId"
            onCellPrepared={this.onCellPrepared}
            onEditorPreparing={this.onEditorPreparing}
            onInitNewRow={this.onInitNewRow}
            onRowInserted={this.DataSourceChange}
            onRowUpdated={this.DataSourceChange}
            onRowRemoved={this.DataSourceChange}
            //onSelectionChanged={onSelectionChanged}
          >
            <Selection mode="single" />
            <Column width={150} dataField="name" caption="Наименование"/>
            <Column width={150} dataField="parentId" caption="Родитель">
              <Lookup dataSource={this.state.depList}
                  displayExpr="name"
                  valueExpr="id"
                  showClearButton={true} />
            </Column>
              <Editing
              allowUpdating={true}
              allowDeleting={true}
              allowAdding={true}
              mode="row" />
          </TreeList>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DepartmentsEditForm);
